module.exports = __webpack_public_path__ + "static/media/Aloy.9344fdab.png";